import React, { Component, useState } from 'react'; 
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from './CustomModal'
import ModalHeader from './ModalHeader'
import ModalBody from './ModalBody'
import ModalFooter from '../Components/ModalFooter'
import swal from '@sweetalert/with-react';
import FormatDateTimeInIST from '../Classes/FormatDateTimeInIST'
import { connect } from 'react-redux'
import { PostManufacturingComment,GetAllManufacturingClearenceDetails } from './../store/actions/expediting.Actions'
import authInstance from '../Classes/AuthHandler';
import Spinner from 'react-bootstrap/Spinner';

class Manufacturing_Clearence extends Component {

    constructor(props) {
        super(props);

        this.state={
            comments:[],
            writeComment:"",
            PoLineId : this.props.PoLineId,
            userId : authInstance.getUserID()
        }
        
        this.modal= this.modal.bind(this); 
        this.onSendComments = this.onSendComments.bind(this);
    }

   
    modal() {
        this.props.toggleManufacturing_Clearence(false)
    }
    componentDidMount() {
        if(this.props.PoLineId){
            this.getComments()
        }
        console.log(this.props.PoLineId,'@@@@@@@@@@@@@@@@')
    }
    dateformate(dateVal){
        let d = new Date(dateVal);
        return d.toLocaleString()
    }
    getComments=async()=>{
            console.log(this.props.PoLineId,"HHHHHHH--------")
            await this.props.GetAllManufacturingClearenceDetails(this.props.PoLineId)
            let comments = this.props.expediting.getManufacturingDetails && this.props.expediting.getManufacturingDetails.recordset ? this.props.expediting.getManufacturingDetails.recordset : []
            this.setState({comments})
            console.log(this.props.expediting.getManufacturingDetails,"CCCCCCCCCCCCCCCCCCCCC")
    }
    async onSendComments(){
        //this.modal()
        let roles = parseInt(Object.keys(authInstance.getRoles())[0])
        let groups = parseInt(Object.keys(authInstance.getGroups())[0])
        let input = {
            PoLineId: this.props.PoLineId,
            Comment: this.state.writeComment,            
            RoleId: roles,
            GroupId: groups,            
            UserId: authInstance.getUserID()
        }
        console.log(input,"#####")
        await this.props.PostManufacturingComment(input)  
        this.state.writeComment=""
        this.setState({writeComment:this.state.writeComment})
        this.getComments()
    }
    hChange = (e)=>{
        let writeComment = this.state.writeComment
        writeComment = e.target.value;
        this.setState({writeComment});
        //console.log(this.state.writeComment,"@@@@@@@")
    }
    handleKeyPress = async (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            await this.onSendComments()
            return false;
        }
    }

 render(){
    // console.log(this.props.varId,'*********************')
 return(
     <div>
      
        <div>
        <Modal  isOpen={this.props.action} >
            <div className={"modal-bg" + (this.props.action === 'false'  ? 'open' : '')}>
                <div className={"modal-bg" + (this.state.OpenVersionModal == true  ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header">
                            <div className="modal-text"><h4 > Manufacturing Clearence : </h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                <ModalBody Style="modal-body modalbodys">
                <div className="row ">
                    <div className="col-8"></div>
                    <div className="col-4 pb-2">
                    </div>
                    </div> 
                    {this.state.comments && this.state.comments.length < 1 && <div className="row col-sm-12" style={{ textAlign: "center", display: "block", top: "40%" }}>
                        <Spinner animation="grow" role="status" variant="warning">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                        <div id="mydiv">Hey No Comments Yet !</div>
                    </div>}
                    <div>
                    </div>    
                    {
                        this.state.comments && this.state.comments.map((item,i)=>{
                            let color = ""
                            {item.RoleId == 7 && item.GroupId == 7 ? color = "#c8f5d8" : item.RoleId == 8 && item.GroupId == 8 ? color = "#d6f5d6" : item.RoleId == 9 && item.GroupId == 10 ? color = "#FAFAD2" : item.RoleId == 10 && item.GroupId == 11 ? color = "#D0EDF0" : item.RoleId == 8 && item.GroupId == 9 ? color = "#F5F5DC" : item.RoleId == 6 ? color = "#ffeecc" : color = ""}
                            //role and Group for Color for AP Team 8,8
                            //role and Group for Expiditing and Teams 7,7
                            //role and Group for Finance HOD 9,10
                            //role and Group for Supply Chain Head 10,11
                            //role and Group for Treasury Team */} 8,9
                            return <div className={item.UserId == this.state.userId  ? "pl-4 ml-4 float-right" : "pr-4 mr-4 float-left"} >
                                {item.Comments == "NA" ? null 
                                :
                                    <div className="row border border-radius-modal ml-2 mr-2 mt-2" style={{backgroundColor : color}} >
                                        <div className="col-12" >
                                            <div className=" row text-left">                                                      
                                                <div className="col-12">{item.Comment}</div>
                                                <div></div>
                                                <div className="col-12 mb-2 mt-2">
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="float-left" style={{fontSize:"11px"}}>{FormatDateTimeInIST(item.CreatedOn)}</div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="float-right" style={{fontSize:"11px"}}>Commnted By : {item.UserName}</div>
                                                    </div>
                                                </div>
                                                    
                                                </div>                                                    
                                            </div>
                                                        
                                        </div>
                                    </div>
                                }
                                            
                                </div>
                            }) 
                    }
                    </ModalBody>
                </div>
                <div className="">    
                    <ModalFooter>
                        <form>
                            <div className="row mt-2 mb-2 ml-2 mr-2">
                                <div className="col-md-10 mt-2">
                                    <input type="text" className="form-control" placeholder="Enter Your Comment Here" value={this.state.writeComment} onChange={(e)=>this.hChange(e)} onKeyPress={(e) => this.handleKeyPress(e)}/>
                                </div>
                                <div className="col-md-2 mt-1 pl-4">
                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"paper-plane"}  color={"red"} title="send" size="2x" onClick={()=>this.onSendComments()}/>
                                </div>
                            </div>
                        </form>
                    </ModalFooter>
                </div>
            </div>
        </Modal>         
        </div>
        
    </div>
       
     
 )
 
  }
}
 

const mapStateToProps  = (state) => ({ expediting: state.expediting })
export default connect(mapStateToProps, { GetAllManufacturingClearenceDetails, PostManufacturingComment })(Manufacturing_Clearence)
